import DeleteShopOrderItemRequestModelBase from '../_generated/modelBases/delete-shop-order-item-request-model-base';

export default class DeleteShopOrderItemRequestModel extends DeleteShopOrderItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
